import React, { useMemo, useState, useEffect } from "react";
import "../../../../../../styles/ambassadorChallenge/leaderboard.scss";
import LeaderboardRow from "./LeaderboardRow";
import TableRowSkeleton from "./TableRowSkeleton";
import { useAmbassadorChallengeContext } from "../../../../../../contexts/AmbassadorChallengeContext";


const PAGE_SIZE = 10;

const Leaderboard: React.FC = () => {
  const { leaderboardData, loading } = useAmbassadorChallengeContext();
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  

  // Filtered results
  const filtered = leaderboardData && leaderboardData.length > 0 ? useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return leaderboardData;
    return leaderboardData && leaderboardData.filter((p) => p.name.toLowerCase().includes(q));
  }, [leaderboardData, query]) : [];

  const pageCount: number | undefined =
    (filtered && Math.ceil(filtered.length / PAGE_SIZE)) || 0;

  const pageData = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return filtered && filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  useEffect(() => {
    if (page > pageCount && pageCount > 0) setPage(1);
  }, [pageCount, page]);

  const handleExport = () => {
    const rows =
      filtered &&
      filtered.map((p) => ({
        Rank: p.rank,
        User: p.referrer_name,
        "Total referrals": p.total_referrals_count,
        "Valid referrals": p.verified_referrals_count,
        "Last referral time": p.last_referral_time.replace(/^Last:\s*/i, ""),
        Qualified: p.qualified ? "Yes" : "No",
      }));

    const csvHeader = rows && Object.keys(rows[0] || {}).join(",");
    const csvBody =
      rows &&
      rows
        .map((r) =>
          Object.values(r)
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");
    const csv = [csvHeader, csvBody].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leaderboard-export-${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    setPage(1);
  };

  return (
    <section className="leaderboard-card">
      <header className="lb-header">
        <div className="top">
          <div className="lb-title">
            <h3>Live Leaderboard</h3>
            <p className="subtitle">Real-time ranking of all participants</p>
          </div>

          <div className="lb-controls">
            {/* <button className="btn icon-btn" onClick={handleRefresh} disabled={isRefreshing} title="Refresh">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor">
              <path d="M21 12a9 9 0 1 0-2.5 6.08" strokeWidth="1.5"></path>
              <path d="M21 12v-5" strokeWidth="1.5" strokeLinecap="round"></path>
            </svg>
            <span>{isRefreshing ? "Refreshing..." : "Refresh"}</span>
          </button> */}

            {leaderboardData && leaderboardData.length > 0 &&
            <button className="btn primary" onClick={handleExport}>
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
              >
                <path
                  d="M21 15v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4"
                  strokeWidth="1.5"
                ></path>
                <polyline
                  points="7 10 12 15 17 10"
                  strokeWidth="1.5"
                ></polyline>
                <path d="M12 15V3" strokeWidth="1.5"></path>
              </svg>
              <span>Export</span>
            </button>}
          </div>
        </div>

        <div className="bottom">
          <div className="search-wrap">
            <svg
              className="icon search"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="11" cy="11" r="6" strokeWidth="1.5"></circle>
              <path d="M21 21l-4.35-4.35" strokeWidth="1.5"></path>
            </svg>
            <input
              placeholder="Search by user's name"
              value={query}
              onChange={onSearchChange}
              aria-label="Search participants"
            />
          </div>
        </div>
      </header>

      <div className="lb-table">
        <div className="lb-table-head">
          <div className="col rank">Rank</div>
          <div className="col user">User</div>
          <div className="col total">Total referrals</div>
          <div className="col valid">Valid referrals</div>
          <div className="col last">Last referral time</div>
          <div className="col qualified">Qualified</div>
        </div>

        <div className="lb-table-body">

            {loading
            ? Array.from({ length: PAGE_SIZE }).map((_, idx) => (
                <TableRowSkeleton key={idx} />
              ))
            : pageData &&
              pageData.map((item) => (
                <LeaderboardRow key={item.referrer_id} participant={item} />
              ))}

              {pageData && pageData.length < 1 && !loading && <div className="empty">No participants found.</div>}
        </div>

        <div className="lb-footer">
          <div className="page-info">
            Page {page} of {pageCount || 1}
          </div>

          <div className="pagination">
            <button
              className="page-btn"
              onClick={() => setPage((s) => Math.max(1, s - 1))}
              disabled={page <= 1}
            >
              Previous
            </button>
            {/* <div className="page-numbers">
              {Array.from({ length: pageCount }).slice(0, 10).map((_, i) => {
                const pn = i + 1;
                return (
                  <button
                    key={pn}
                    className={`page-number ${pn === page ? "active" : ""}`}
                    onClick={() => setPage(pn)}
                  >
                    {pn}
                  </button>
                );
              })}
            </div> */}
            <button
              className="page-btn"
              onClick={() => setPage((s) => Math.min(pageCount || 1, s + 1))}
              disabled={page >= pageCount}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Leaderboard;
